import { render } from "./CuDialog.vue?vue&type=template&id=b6a880c2"
import script from "./CuDialog.vue?vue&type=script&lang=js"
export * from "./CuDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__